import React, { FC } from 'react';
import styled from 'styled-components';
import { Text } from 'src/components/text/Text';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { ContentWrapper } from 'components/content-wrapper/ContentWrapper';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { colors } from 'src/styles/colors';
import Button from 'antd/es/button';
import { AuthenticationStepKey } from 'logic/store/authentication/authentication.model';
import { useRedirectToPublishOffer } from 'logic/store/offer/offer.hooks';

const Content = styled.div<{ minTablet: boolean }>`
  display: flex;
  flex-direction: ${({ minTablet }) => (minTablet ? 'row' : 'column')};
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const Type = styled.div<{ minTablet: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${({ minTablet }) => (minTablet ? '360px' : '100%')};
  height: 430px;
  border: 1px solid ${colors.gray15};
  border-radius: 10px;
  margin-right: ${({ minTablet }) => (minTablet ? '23px' : '0')};
  margin-bottom: ${({ minTablet }) => (minTablet ? '70px' : '48px')};
  &:last-child {
    margin-right: 0;
  }
  background-color: ${colors.lightTeal};;
`;

const Types = [
  {
    icon: '/icons/aboutus/type1.png',
    type: 'first',
  },
  {
    icon: '/icons/aboutus/type2.png',
    type: 'second',
  },
  {
    icon: '/icons/aboutus/type3.png',
    type: 'last',
  },
];

export const TutorTypes: FC = () => {
  const { minTablet } = useBreakpoints();
  const createOffer = useRedirectToPublishOffer(AuthenticationStepKey.RegisterWithEmail);

  return (
    <ContentWrapper style={{ flexDirection: 'column' }} padding={minTablet ? '120px 0' : '64px 0'}>
      <Text
        color="blueGray"
        fontWeight={600}
        size={minTablet ? 38 : 26}
        textAlign="center"
        style={{ marginBottom: minTablet ? 70 : 22 }}
      >
        {translate(translationKeys.aboutus.typesTitle)}
      </Text>
      <Content minTablet={minTablet}>
        {Types.map(({ icon, type }, idx) => (
          <Type key={idx} minTablet={minTablet}>
            <img src={icon} alt={translate(translationKeys.aboutus.type[type].title)} />
            <Text
              color="black"
              fontWeight={600}
              size={18}
              textAlign="center"
              style={{ marginTop: 32, marginBottom: 6 }}
            >
              {translate(translationKeys.aboutus.type[type].title)}
            </Text>
            <Text color="black" size={14} textAlign="center" style={{ width: 200 }}>
              {translate(translationKeys.aboutus.type[type].subTitle)}
            </Text>
          </Type>
        ))}
      </Content>
      <Button
        type="primary"
        onClick={createOffer}
        style={{ width: minTablet ? 360 : '100%', margin: '0 auto', height: 48 }}
      >
        {translate(translationKeys.aboutus.typesButton)}
      </Button>
    </ContentWrapper>
  );
};
